import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type LoadMoreBtnProps = {
  showMore: boolean;
  handleShowMoreClick: () => any;
};

const LoadMoreBtn = ({ showMore, handleShowMoreClick }: LoadMoreBtnProps) => {
  return (
    <div className="clinical-obs__load-more-proband-btn-wrapper">
      <div
        className="clinical-obs__load-more-proband-btn"
        onClick={handleShowMoreClick}
      >
        <span className="clinical-obs__load-more-proband-btn-icon">
          {showMore ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )}
        </span>
        <span className="clinical-obs__load-more-proband-btn-label">
          {showMore ? 'less' : 'more'}
        </span>
      </div>
    </div>
  );
};

export default LoadMoreBtn;
